import { Observable, of } from 'rxjs';

export function getFurtureFeatures(): Observable<any[]> {
     return of([
          {
               id: 1,
               descriptionShown: false,
               isNew: false,
               visible: true,
               name: "Export Enhancements",
               description: `Future releases will include enhancements to the export feature such as 
               the ability to export your logbook data to PDF and the ability to export your data in 
               a format that is compatible with 3rd party logbook applications.`
          },
          // {
          //      id: 2,
          //      descriptionShown: false,
          //      isNew: false,
          //      visible: false,
          //      name: "Add/Edit Flights",
          //      description: "As it's possible some flight records may have errors or missing information, this feature will allow you to edit your flights.  When this feature is implemented, you will also be able to add pilot landings.  The implementation of this feature will start with the ability to edit flights and a period of testing.  After testing the feaure validity, we will then move into implementing the ability to add pilot records as individual flights or whole sequences."
          // },
          // {
          //      id: 3,
          //      descriptionShown: false,
          //      isNew: false,
          //      visible: false,
          //      name: "Settings",
          //      description: "A preferences section will be added to the app to allow you to set your default preferences that will affect the app globally and sync between devices.  This will include setting your default view, default filters, default sort order, and other preferences."
          // }
     ]);
}